/**
 * SFL logo rotate — header + footer
 * Alternates happy kids ↔ funny kids eating ~every 1s (GIF-style).
 * Honors prefers-reduced-motion (stays on frame A).
 */
(function () {
  var INTERVAL_MS = 1000;

  function initOne(root) {
    if (!root || root.dataset.sflLogoBound) return;
    var imgs = root.querySelectorAll('img[data-sfl-logo-frame]');
    if (imgs.length < 2) return;
    root.dataset.sflLogoBound = '1';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      imgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === 0);
      });
      return;
    }

    var i = 0;
    imgs.forEach(function (img, idx) {
      img.classList.toggle('is-active', idx === 0);
    });
    setInterval(function () {
      imgs[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-active');
    }, INTERVAL_MS);
  }

  function boot() {
    document.querySelectorAll('[data-sfl-logo-rotate]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
